export default __webpack_public_path__ + "static/media/102-balearic-islands.e0a5f1a5.svg";